import React from "react";

import isIntuit from "Intuit/isIntuit";

import CobaltBodyText from "Cobalt/BodyText";
import ClassicBodyText from "Common/BodyText";

import { useThemeContext } from "./Context";

export const BodyText = ({ children, cobaltProps = {}, classicProps = {}, intuitProps = {}, ...rest }) => {
  const { intuit, cobalt } = useThemeContext();
  return isIntuit() && intuit ? (
    <ClassicBodyText {...rest} {...intuitProps}>
      {children}
    </ClassicBodyText>
  ) : cobalt ? (
    <CobaltBodyText {...rest} {...cobaltProps}>
      {children}
    </CobaltBodyText>
  ) : (
    <ClassicBodyText {...rest} {...classicProps}>
      {children}
    </ClassicBodyText>
  );
};

export const Caption = ({ children, cobaltProps = {}, ...rest }) => {
  const cobaltPropsWithSize = {
    ...cobaltProps,
    size: "caption",
  };

  return (
    <BodyText {...rest} cobaltProps={cobaltPropsWithSize}>
      {children}
    </BodyText>
  );
};

export const SubBody = ({ children, cobaltProps = {}, ...rest }) => {
  const cobaltPropsWithSize = {
    ...cobaltProps,
    size: "subBody",
  };

  return (
    <BodyText {...rest} cobaltProps={cobaltPropsWithSize}>
      {children}
    </BodyText>
  );
};
export const Body2 = ({ children, cobaltProps = {}, ...rest }) => {
  const cobaltPropsWithSize = {
    ...cobaltProps,
    size: "body2",
  };

  return (
    <BodyText {...rest} cobaltProps={cobaltPropsWithSize}>
      {children}
    </BodyText>
  );
};
export const Body1 = ({ children, cobaltProps = {}, ...rest }) => {
  const cobaltPropsWithSize = {
    ...cobaltProps,
    size: "body1",
  };

  return (
    <BodyText {...rest} cobaltProps={cobaltPropsWithSize}>
      {children}
    </BodyText>
  );
};

export default BodyText;
